import { useEffect, useRef, useState } from "react";
import _ from "lodash";
import dayjs from "dayjs";
import { Table, Card, Space, Popover, Row, Col, Radio } from 'antd';
import { formattedAmount } from "../../utils/index";
import { useDataStore } from "../../store";
import './CommonTrading.css';

export function CommonTradings (){
    return <Space direction="horizontal" className="common-trading">
        <Row gutter={16}>
            <Col span={12}>
                <CommonCards />
            </Col>
            <Col span={12}>
                <FinancialTransactions />
            </Col>
        </Row>
    </Space>
}

function CommonCards (){
    const commonTradings = useDataStore(state => state.commonTradings);
    const [dataSource, setDataSource] = useState([]); // Table的数据源

    useEffect(() => {
        if (!commonTradings || commonTradings.length === 0) {
            return;
        }
        // Transform commonTradings into a format suitable for the table
        let source = _.entries(commonTradings).map(([bank, item]) => {
            if( item.cardType === 'credit' || item.cardType === 'debit' ) {
                return {
                    key: `${bank}-${item.cardType}`,
                    bankName: bank,
                    count: item.count,
                    expenditure: item.expenditure,
                    withdrawal: item.withdrawal,
                    other: item.other
                };
            }
        }).filter( n => !!n);

        setDataSource(source);

    }, [ commonTradings ]);

    return <Card title="银行卡列表">
        <Table pagination={{ pageSize: 5, showSizeChanger: false }} dataSource={dataSource} columns={[
            { title: "银行卡号", dataIndex: "bankName", key: "bankName" },
            { title: "交易次数", dataIndex: "count", key: "count" },
            { title: "从卡支出", dataIndex: "expenditure", key: "expenditure", render: (text) => formattedAmount(text) },
            { title: "提现到卡", dataIndex: "withdrawal", key: "withdrawal", render: (text) => formattedAmount(text) },
            { title: "不计收支", dataIndex: "other", key: "other", render: (text) => formattedAmount(text) }
        ]}>
        </Table>
    </Card>
}

function FinancialTransactions (){

    const getOrderDetail = useDataStore(state => state.getOrderDetail);
    const partyTrading = useDataStore(state => state.partyTrading);
    const inquiryTime = useDataStore(state => state.inquiryTime);
    const [ flowDataSource, setFlowDataSource ] = useState([]);
    const [ flowTimeSpan, setFlowTimeSpan ] = useState( 1 ); // 默认显示最近3个月的

    useEffect(() => {

        if( !partyTrading || partyTrading.length === 0 || !inquiryTime ) {
            return;
        }

        //统计时间范围内的交易数据
        let filteredFlowData = _.filter(_.entries(partyTrading).map(([key, item]) => {
            let orderFromParty = { "income": 0, "expense": 0, "other": 0,
                "count": 0, "party": item.party, 
                "incomeOrders": [], "expenseOrders": [], "otherOrders": [] };

            item.incomeOrders.concat(item.expenseOrders).forEach( order => {
                let detail = getOrderDetail(order);

                //判断是否为flowtimeSpan内的订单
                let orderTime = dayjs(detail.TIME_YMD);
                let now = dayjs( inquiryTime ); 
                let distance = now.diff(orderTime, 'day'); //计算距离当前时间的天数

                //根据distance和flowTimeSpan来判断是否统计该订单
                if ((flowTimeSpan === 0 && distance <= 30)
                    || (flowTimeSpan === 1 && distance <= 90)
                    || (flowTimeSpan === 2 && distance <= 180)
                    || (flowTimeSpan === 3)
                ) {
                    if( detail._IE === 0 ){
                        orderFromParty.income += detail.AMOUNT;
                        orderFromParty.incomeOrders.push( detail.ID );
                    }
                    else if( detail._IE === 1 ) {
                        orderFromParty.expense += detail.AMOUNT;
                        orderFromParty.expenseOrders.push( detail.ID );
                    }
                    else {
                        orderFromParty.other += detail.AMOUNT;
                        orderFromParty.otherOrders.push( detail.ID );
                    }
                    orderFromParty.count += 1;
                }
            });
            return orderFromParty;
        }), item => {
            let condition1 = item.income + item.expense < 1000; //总交易额小于1000
            return !condition1;
        });

        //根据收入与支出之和倒序排列
        filteredFlowData = _.sortBy(filteredFlowData, (item) => {
            return Math.abs(item.income) + Math.abs(item.expense)
        }).reverse();

        setFlowDataSource(filteredFlowData);

    }, [ partyTrading, flowTimeSpan, inquiryTime ]);

    return <Card title="资金往来" extra={(() => {
            return <div className="flow-time-span">
                <Radio.Group size="middle" value={flowTimeSpan} onChange={(e) => {
                    setFlowTimeSpan(e.target.value);
                }}>
                    <Radio.Button key="last-month" value={0}>近一个月</Radio.Button>
                    <Radio.Button key="last-three-months" value={1}>近三个月</Radio.Button>
                    <Radio.Button key="last-six-months" value={2}>近半年</Radio.Button>
                    <Radio.Button key="all" value={3}>全部</Radio.Button>
                </Radio.Group>
            </div>;
        })()}>
        <Table pagination={{ pageSize: 5, showSizeChanger: false }}
            rowKey="party"
            dataSource={flowDataSource} columns={[
            { title: '交易人', dataIndex: "party", key: "party" },
            { title: '交易次数', dataIndex: "count", key: "count" },
            { title: '收入', dataIndex: "income", key: "income", render: (text) => formattedAmount(text) },
            { title: '支出', dataIndex: "expense", key: "expense", render: (text) => formattedAmount(text) },
            {
                title: '操作',
                key: 'details',
                render: (text, record) => {
                    let orders = record.expenseOrders.concat(record.incomeOrders);
                    let ordersDetail = _.sortBy(orders.map( order => {
                        //根据订单ID获取订单详情，并根据时间倒序
                        return getOrderDetail(order);
                    }), 'TIME_YMD').reverse();
                    return <Popover trigger="click" content={
                        <Table
                            pagination={{ pageSize: 5, showSizeChanger: false }}
                            dataSource={ordersDetail}
                            rowKey="ID"
                            columns={[
                                { title: '时间', dataIndex: 'TIME_YMD', key: 'TIME_YMD' },
                                { title: '交易说明', dataIndex: 'TYPE', key: 'TYPE' },
                                { title: '收/支', dataIndex: 'IE', key: '_IE' },
                                { title: '交易方式', dataIndex: 'TRADING', key: 'TRADING' },
                                { title: '金额', dataIndex: 'AMOUNT', key: 'AMOUNT', render: (text) => formattedAmount(text) },
                                { title: '交易对方', dataIndex: 'PARTY', key: 'PARTY' },
                            ]}
                        />
                    } title={`与 ${record.party} 的交易明细`}>
                        <a>查看明细</a>
                    </Popover>;
                }
            }
        ]}>
        </Table>
    </Card>
}
